export const identifyTypes = {
  '01': '身份证',
  '02': '军官证',
  '03': '护照',
  '04': '台胞证',
  '05': '回乡证',
  '06': '港澳通行证',
  '07': '学生证',
  '08': '退休证',
  '99': '其它'
}

export const provinceFilter = {
  '11': '北京',
  '12': '天津',
  '13': '河北',
  '14': '山西',
  '31': '上海',
  '32': '江苏',
  '33': '浙江',
  '34': '安徽',
  '35': '福建',
  '36': '江西',
  '37': '山东',
  '41': '河南',
  '42': '湖北',
  '43': '湖南',
  '44': '广东',
  '45': '广西',
  '46': '海南',
  '50': '重庆',
  '51': '四川',
  '52': '贵州',
  '53': '云南',
  '90': '深圳',
  '15': '内蒙古',
  '21': '辽宁',
  '22': '吉林',
  '23': '黑龙江',
  '61': '陕西',
  '62': '甘肃',
  '63': '青海',
  '64': '宁夏',
  '65': '新疆',
  '54': '西藏',
  '91': '龙禹',
  '93': '燃料油'
}

/**
 * { text: '单位管理主卡', value: '1D' },
  { text: '下级管理主卡', value: '2F' },
  { text: '副卡管理卡', value: '3F' },
  { text: '副卡', value: '1F' }
 */
export const ecardTypes = {
  // '1B': '单位单用户主卡',
  '1D': '单位管理主卡',
  '1F': '副卡',
  '2F': '下级管理主卡',
  '3F': '副卡管理卡'
}

export const invoiceTypes = {
  1: '普票',
  2: '增票'
}

export const invTypes = {
  '01': '充值开票',
  '02': '消费开票'
}

export function getProvince(cardNo) {
  if (cardNo && cardNo.length === 19) {
    const value = cardNo.substring(6, 8)
    return value === '86' ? cardNo.substring(8, 10) : value
  }
}

export const patternCarNo = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
